import { useEffect, useState } from 'react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import type { Device } from '../../../domain/Device';

// El dispositivo para montar el home de una estación por su id (los datos
// del clima los carga el propio StationHome).
export function useStationDevice(id: string) {
  const { devices: deviceRepo } = useRepositories();
  const [device, setDevice] = useState<Device | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setDevice(null);
    deviceRepo
      .get(id)
      .then(({ device: found }) => !cancelled && setDevice(found))
      .catch((err) => !cancelled && setError(err instanceof Error ? err.message : 'No se pudo cargar la estación.'));
    return () => {
      cancelled = true;
    };
  }, [id, deviceRepo]);

  return { device, error };
}
